// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchAiSuggestionDuplicateTargetsQueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
}>;


export type FetchAiSuggestionDuplicateTargetsQuery = { __typename?: 'Query', clientOrganizations: { __typename?: 'ClientOrganizationConnection', edges?: Array<{ __typename?: 'ClientOrganizationEdge', node?: { __typename?: 'ClientOrganization', id: string, name: string } | null } | null> | null }, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null }, testamentaryEntities: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: { __typename?: 'TestamentaryEntity', id: string, displayName: string, createdFromEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null } } | null } | null> | null } };

export type MarkSuggestionAsDuplicateMutationVariables = Types.Exact<{
  input: Types.MarkSuggestionAsDuplicateInput;
}>;


export type MarkSuggestionAsDuplicateMutation = { __typename?: 'Mutation', markSuggestionAsDuplicate: { __typename?: 'AISuggestion', id: string, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null } };

export const Operations = {
  Query: {
    FetchAISuggestionDuplicateTargets: 'FetchAISuggestionDuplicateTargets' as const
  },
  Mutation: {
    MarkSuggestionAsDuplicate: 'MarkSuggestionAsDuplicate' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const FetchAiSuggestionDuplicateTargetsDocument = gql`
    query FetchAISuggestionDuplicateTargets($householdID: ID!) {
  clientOrganizations(where: {hasHouseholdWith: [{id: $householdID}]}) {
    edges {
      node {
        id
        name
      }
    }
  }
  entities(where: {hasHouseholdWith: {id: $householdID}}) {
    edges {
      node {
        id
        kind
        stage
        subtype {
          id
          displayName
        }
      }
    }
  }
  testamentaryEntities(where: {householdID: $householdID}) {
    edges {
      node {
        id
        displayName
        createdFromEntities {
          edges {
            node {
              id
              subtype {
                id
                displayName
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchAiSuggestionDuplicateTargetsQuery__
 *
 * To run a query within a React component, call `useFetchAiSuggestionDuplicateTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAiSuggestionDuplicateTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAiSuggestionDuplicateTargetsQuery({
 *   variables: {
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useFetchAiSuggestionDuplicateTargetsQuery(baseOptions: Apollo.QueryHookOptions<FetchAiSuggestionDuplicateTargetsQuery, FetchAiSuggestionDuplicateTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAiSuggestionDuplicateTargetsQuery, FetchAiSuggestionDuplicateTargetsQueryVariables>(FetchAiSuggestionDuplicateTargetsDocument, withFetchPolicyContext(options));
      }
export function useFetchAiSuggestionDuplicateTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAiSuggestionDuplicateTargetsQuery, FetchAiSuggestionDuplicateTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAiSuggestionDuplicateTargetsQuery, FetchAiSuggestionDuplicateTargetsQueryVariables>(FetchAiSuggestionDuplicateTargetsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchAiSuggestionDuplicateTargetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchAiSuggestionDuplicateTargetsQuery, FetchAiSuggestionDuplicateTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAiSuggestionDuplicateTargetsQuery, FetchAiSuggestionDuplicateTargetsQueryVariables>(FetchAiSuggestionDuplicateTargetsDocument, withFetchPolicyContext(options));
        }
export type FetchAiSuggestionDuplicateTargetsQueryHookResult = ReturnType<typeof useFetchAiSuggestionDuplicateTargetsQuery>;
export type FetchAiSuggestionDuplicateTargetsLazyQueryHookResult = ReturnType<typeof useFetchAiSuggestionDuplicateTargetsLazyQuery>;
export type FetchAiSuggestionDuplicateTargetsSuspenseQueryHookResult = ReturnType<typeof useFetchAiSuggestionDuplicateTargetsSuspenseQuery>;
export type FetchAiSuggestionDuplicateTargetsQueryResult = Apollo.QueryResult<FetchAiSuggestionDuplicateTargetsQuery, FetchAiSuggestionDuplicateTargetsQueryVariables>;
export const MarkSuggestionAsDuplicateDocument = gql`
    mutation MarkSuggestionAsDuplicate($input: MarkSuggestionAsDuplicateInput!) {
  markSuggestionAsDuplicate(input: $input) {
    id
    acceptanceStatus
  }
}
    `;
export type MarkSuggestionAsDuplicateMutationFn = Apollo.MutationFunction<MarkSuggestionAsDuplicateMutation, MarkSuggestionAsDuplicateMutationVariables>;

/**
 * __useMarkSuggestionAsDuplicateMutation__
 *
 * To run a mutation, you first call `useMarkSuggestionAsDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSuggestionAsDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSuggestionAsDuplicateMutation, { data, loading, error }] = useMarkSuggestionAsDuplicateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkSuggestionAsDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<MarkSuggestionAsDuplicateMutation, MarkSuggestionAsDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSuggestionAsDuplicateMutation, MarkSuggestionAsDuplicateMutationVariables>(MarkSuggestionAsDuplicateDocument, options);
      }
export type MarkSuggestionAsDuplicateMutationHookResult = ReturnType<typeof useMarkSuggestionAsDuplicateMutation>;
export type MarkSuggestionAsDuplicateMutationResult = Apollo.MutationResult<MarkSuggestionAsDuplicateMutation>;
export type MarkSuggestionAsDuplicateMutationOptions = Apollo.BaseMutationOptions<MarkSuggestionAsDuplicateMutation, MarkSuggestionAsDuplicateMutationVariables>;